import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { GraduationCap, Users, FileCheck, Calendar, FileBadge, BarChart, Building2 } from 'lucide-react';
import Header from './Header';
//@ts-ignore
import courses from '../assets/images/index-page-images/courses1.png';
//@ts-ignore
import dashboard from '../assets/images/index-page-images/dashboard.png';
//@ts-ignore
import students from '../assets/images/index-page-images/student-management.png';
//@ts-ignore
import coursesManagement from '../assets/images/index-page-images/course-management.png';
//@ts-ignore
import certificateManagement from '../assets/images/index-page-images/certificate-management.png';
//@ts-ignore
import batchesManagement from '../assets/images/index-page-images/batches-management.png';
//@ts-ignore
import lmsManagement from '../assets/images/index-page-images/lms-management.png';
//@ts-ignore
import analyticsManagement from '../assets/images/index-page-images/analytics-management.png';
const Index = () => {

  const [platformImages, setPlatformImages] = useState([
    courses, dashboard, students, coursesManagement, certificateManagement, batchesManagement, lmsManagement, analyticsManagement
  ])
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <nav className="bg-white border-b border-gray-200">
        {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <span className="text-2xl font-bold text-bytesplash-blue">ByteSplash</span>
              </div>
            </div>
            <div className="flex items-center">
              <Button asChild variant="blue" size="sm" className="mr-3">
                <Link to="/dashboard">Login</Link>
              </Button>
              <Button asChild variant="outline" size="sm">
                <Link to="/dashboard">Contact Us</Link>
              </Button>
            </div>
          </div>
        </div> */}
      </nav>

      {/* Hero Section */}
      <motion.section
        className="relative bg-gradient-to-br from-bytesplash-blue to-blue-900 text-white py-20 md:py-32"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="absolute inset-0 opacity-10 bg-cover bg-center mix-blend-overlay"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
                Streamline Your Educational Management
              </h1>
              <p className="text-lg md:text-xl opacity-90 mb-8">
                A comprehensive registration portal for educational institutions to manage students, courses, certifications, and more - all in one place.
              </p>
              <div className="flex flex-wrap gap-4">
                <Button asChild size="lg" variant="blue" className="bg-white text-bytesplash-blue hover:bg-gray-100 font-medium">
                  <Link to="/dashboard">Get Started</Link>
                </Button>
                <Button asChild size="lg" variant="blue" className="bg-white text-bytesplash-blue hover:bg-gray-100 font-medium">
                  <Link to="/dashboard">Learn More</Link>
                </Button>
              </div>
            </motion.div>
            <motion.div
              initial={{ x: 50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="hidden md:block"
            >
              <div className="relative h-80 w-full">
                <div className="absolute right-0 top-4 bg-white/10 backdrop-blur-sm rounded-xl p-2 shadow-lg border border-white/20 w-full max-w-md max-w-[350px] ">
                  <img src={courses} alt="Dashboard Preview" className="rounded-md w-full" />
                </div>
                <div className="absolute left-0 bottom-4 bg-white/10 backdrop-blur-sm rounded-xl p-2 shadow-lg border border-white/20 w-full max-w-[350px] max-h-[450px]">
                  <img src={dashboard} alt="Registration Preview" className="rounded-md w-full h-auto max-h-[400px]" />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Features Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text -2xl md:text-4xl font-bold mb-4 text-gray-900">Powerful Features</h2>
            <p className="text-lg text-gray-600 max-w -2xl mx-auto">
              Our platform provides comprehensive tools to streamline educational administration, student management, and certification processes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-md transition-all border-t-4 border-t-blue-500">
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                    <Users className="h-6 w-6 text-blue-600" />
                  </div>
                  <CardTitle>Student Management</CardTitle>
                  <CardDescription>
                    Complete registration and management workflows for students.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Student registration with personal details
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Course enrollment and tracking
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Fee management and payment tracking
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Student progress reports
                    </li>
                  </ul>
                  <div className="mt-6 w-full max-w-md aspect-[16/9] bg-gray-100 rounded-md overflow-hidden">
                    <img src={students} alt="Student Management" className="w-full h-full object-cover" />
                  </div>
                </CardContent>
              </Card>
            </motion.div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-md transition-all border-t-4 border-t-green-500">
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center mb-4">
                    <GraduationCap className="h-6 w-6 text-green-600" />
                  </div>
                  <CardTitle>Course Management</CardTitle>
                  <CardDescription>
                    Create and manage courses, modules, and batches.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-green-500 mr-2"></div>
                      Course creation with detailed information
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-green-500 mr-2"></div>
                      Module and content management
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-green-500 mr-2"></div>
                      Batch scheduling and instructor assignment
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-green-500 mr-2"></div>
                      Course analytics and reporting
                    </li>
                  </ul>
                  <div className="mt-6 w-full max-w-md aspect-[16/9] bg-gray-100 rounded-md overflow-hidden">
                    <img src={coursesManagement} alt="Course Management" className="w-full h-full object-cover" />
                  </div>
                </CardContent>
              </Card>
            </motion.div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-md transition-all border-t-4 border-t-amber-500">
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center mb-4">
                    <FileBadge className="h-6 w-6 text-amber-600" />
                  </div>
                  <CardTitle>Certification System</CardTitle>
                  <CardDescription>
                    Generate and manage certificates and ID cards.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-amber-500 mr-2"></div>
                      Certificate generation and verification
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-amber-500 mr-2"></div>
                      Digital and printable formats
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-amber-500 mr-2"></div>
                      ID card creation and management
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-amber-500 mr-2"></div>
                      Certificate tracking and validation
                    </li>
                  </ul>
                  <div className="mt-6 w-full max-w-md aspect-[16/9] bg-gray-100 rounded-md overflow-hidden">
                    <img src={certificateManagement} alt="Certification System" className="w-full h-full object-cover" />
                  </div>
                </CardContent>
              </Card>
            </motion.div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-md transition-all border-t-4 border-t-purple-500">
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-purple-100 flex items-center justify-center mb-4">
                    <Calendar className="h-6 w-6 text-purple-600" />
                  </div>
                  <CardTitle>Batch & Schedule Management</CardTitle>
                  <CardDescription>
                    Create and manage batches with flexible scheduling.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-purple-500 mr-2"></div>
                      Batch creation and student assignment
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-purple-500 mr-2"></div>
                      Class scheduling and calendar management
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-purple-500 mr-2"></div>
                      Instructor allocation and availability
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-purple-500 mr-2"></div>
                      Automated notifications and reminders
                    </li>
                  </ul>
                  <div className="mt-6 w-full max-w-md aspect-[16/9] bg-gray-100 rounded-md overflow-hidden">
                    <img src={batchesManagement} alt="Batch Management" className="w-full h-full object-cover" />
                  </div>
                </CardContent>
              </Card>
            </motion.div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-md transition-all border-t-4 border-t-red-500">
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center mb-4">
                    <FileCheck className="h-6 w-6 text-red-600" />
                  </div>
                  <CardTitle>LMS Integration</CardTitle>
                  <CardDescription>
                    Seamless learning management system integration.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-red-500 mr-2"></div>
                      LMS access management for students
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-red-500 mr-2"></div>
                      Course content integration
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-red-500 mr-2"></div>
                      Progress tracking and reporting
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-red-500 mr-2"></div>
                      Access request management
                    </li>
                  </ul>
                  <div className="mt-6 w-full max-w-md aspect-[16/9] bg-gray-100 rounded-md overflow-hidden">
                    <img src={lmsManagement} alt="LMS Integration" className="w-full h-full object-cover" />
                  </div>
                </CardContent>
              </Card>
            </motion.div>

            <motion.div
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <Card className="h-full hover:shadow-md transition-all border-t-4 border-t-blue-500">
                <CardHeader>
                  <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center mb-4">
                    <BarChart className="h-6 w-6 text-blue-600" />
                  </div>
                  <CardTitle>Advanced Analytics</CardTitle>
                  <CardDescription>
                    Comprehensive reports and analytics dashboards.
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Enrollment and revenue analytics
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Student performance metrics
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Course popularity and feedback tracking
                    </li>
                    <li className="flex items-center">
                      <div className="h-1.5 w-1.5 rounded-full bg-blue-500 mr-2"></div>
                      Custom report generation
                    </li>
                  </ul>
                  <div className="mt-6 w-full max-w-md aspect-[16/9] bg-gray-100 rounded-md overflow-hidden">
                    <img src={analyticsManagement} alt="Analytics Dashboard" className="w-full h-full object-cover" />
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Screenshots Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text -2xl md:text-4xl font-bold mb-4 text-gray-900">Platform Screenshots</h2>
            <p className="text-lg text-gray-600 max-w -2xl mx-auto">
              Get a glimpse of our intuitive interface designed for educational administrators and staff.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {platformImages.map((item) => (
              <motion.div
                key={item}
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow"
              >
                <img
                  src={item}
                  alt={`Screenshot ${item}`}
                  className="w-full aspect-video object-cover"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-bytesplash-blue py-16 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text -2xl md:text-4xl font-bold mb-6">Ready to streamline your educational management?</h2>
          <p className="text-lg opacity-90 mb-8 max-w -2xl mx-auto">
            Join hundreds of educational institutions that have transformed their administrative workflows with our registration portal.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button asChild size="lg" variant="blue" className="bg-white text-bytesplash-blue hover:bg-gray-100 font-medium">
              <Link to="/dashboard">Get Started</Link>
            </Button>
            <Button asChild size="lg" variant="blue" className="bg-white text-bytesplash-blue hover:bg-gray-100 font-medium">
              <Link to="/dashboard">Request Demo</Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-500 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">ByteSplash</h3>
              <p className="text-sm mb-4">
                A comprehensive education management platform providing powerful tools for student registration, course management, and more.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white">
                  <span className="sr-only">Facebook</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <span className="sr-only">Twitter</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <span className="sr-only">LinkedIn</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Features</h3>
              <ul className="space-y-2">
                <li><a href="/students" className="hover:text-white transition-colors">Student Management</a></li>
                <li><a href="/courses" className="hover:text-white transition-colors">Course Management</a></li>
                <li><a href="/batches" className="hover:text-white transition-colors">Batch Scheduling</a></li>
                <li><a href="/certificates" className="hover:text-white transition-colors">Certification System</a></li>
                <li><a href="/courses" className="hover:text-white transition-colors">LMS Integration</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Resources</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-white transition-colors">Documentation</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Tutorials</a></li>
                <li><a href="#" className="hover:text-white transition-colors">API Reference</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Support Center</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2">
                  <Building2 className="h-5 w-5 mt-0.5 flex-shrink-0" />
                  <span>4th Floor, GR Arcade , PR Layout, Outer Ring Road, Marathahalli, Bengaluru, Karnataka - 560037</span>
                </li>
                <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a href="mailto:info@bytesplash.com" className="hover:text-white">enquires@bytesplash.in</a>
                </li>
                <li className="flex items-center space-x-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <a href="tel:+1234567890" className="hover:text-white">+91 6301 062 858</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-800 text-sm text-center">
            <p>© 2025 ByteSplash Education Management System. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;
